export default {
  data () {
    return {
      consentCheckInterval: null
    }
  },
  methods: {
    /**
     * Start watching a Usercentrics variable inside dataLayer.
     * @param {String} key - The name of the variable (e.g., "eKomi" or "Elfsight")
     * @param {Function} onChange - Callback when consent changes (enabled or disabled)
     */
    watchConsent (key, onChange) {
      const getConsentValue = () => {
        if (!window.dataLayer) return false;

        // Iterate from the end to find the last matching entry
        for (let i = window.dataLayer.length - 1; i >= 0; i--) {
          if (window.dataLayer[i][key] !== undefined) {
            return window.dataLayer[i][key] === true;
          }
        }
        return false; // fallback if key not found
      };

      // Initial check
      let previousValue = getConsentValue();
      onChange(previousValue);

      // Poll for changes
      this.consentCheckInterval = setInterval(() => {
        const currentValue = getConsentValue();
        if (currentValue !== previousValue) {
          previousValue = currentValue;
          onChange(currentValue);
        }
      }, 1000);
    }
  },
  beforeDestroy () {
    clearInterval(this.consentCheckInterval);
  }
};
